import { TypeType } from 'components/faq/FAQ';

const faqs = [
  {
    question: 'What is bid2board?',
    answer: `bid2board is an online marketplace bridging the gap between marine service suppliers
    and ship owners / managers. Ship managers enjoy time efficient, simple and organized
    technical service arrangement, while service suppliers gain increased visibility and
    improved workflows from enquiry receipt until the execution of service.`,
    type: [TypeType.HOMEPAGE, TypeType.SUPPORT],
  },
  {
    question: `Why choose bid2board for your business (as Ship Manager)?
    `,
    answer: `By using bid2board, service arrangements are done in an easy, time – saving, controlled and transparent manner. Apart from having a complete database with the technical details of all your ships’ machinery, you can expect improved service quality based on the platform’s review and supplier scoring system. The bidding process that takes place before selecting a service offer allows for more competitive offers and a greater variety of service suppliers to choose from. Finally, by reviewing data accumulated in the platform you have insights on maintenance costs, areas where technical services are preferrable and you can compare results between ships and equipment.`,
    type: [TypeType.HOMEPAGE, TypeType.SUPPORT],
  },
  {
    question: `What information do I need to include in my profile (as Service Supplier)?`,
    answer: `By including detailed information in your profile, you increase the chances of receiving RFQs. Following the creation of your profile, after you have contacted us, you will be guided to fill – in information on the following:
    All the technical equipment that your company can provide service for.
    All services (overhauling, reconditioning, upgrade, repairs, troubleshooting, etc) for each equipment that your company can perform.
    The ports where your company has workshops and the areas where your service engineers can attend.
    All certifications that your company holds, i.e. maker or Classification Societies approvals. 
    `,
    type: [TypeType.SUPPLIER, TypeType.SUPPORT],
  },
  {
    question: `Why choose bid2board for your business (as Service Supplier)?
    `,
    answer: `By using bid2board you gain visibility to ship owners / managers who can otherwise be difficult or costly to reach. You can reduce the time spent in service arrangements, while performing same in a transparent and controlled manner. The automated process and data provided during the bidding process allows you to have insights on the competition and improve your offers. By analyzing data derived from the platform you can improve the services your offer, identify customer needs better and grow your business by increasing your service volume.`,
    type: [TypeType.HOMEPAGE, TypeType.SUPPLIER, TypeType.SUPPORT],
  },
  {
    question: `How do ship owners / managers find my company? Will I receive RFQs (as Service Supplier)?`,
    answer: `The platform operates by matching the requested service with service suppliers capable of performing the requested service. The matching algorithm is based on the information included in your profile for the services that your company can provide and matches this information to the details included in the service request from the ship manager. The ship owner / manager may choose whether the service is performed by a local supplier only or whether travelling service suppliers may be contacted to provide a quotation as well. Finally, the ship owner / manager may choose the certification necessary that a service supplier should be able to demonstrate (i.e. approved by a specific Classification Society or maker).`,
    type: [TypeType.SUPPLIER, TypeType.SUPPORT],
  },
  {
    question:
      'How can I find a supplier for a service I need (as Ship Manager)?',
    answer: `The platform operates by matching the requested service with service suppliers capable
    of performing same service. The matching criteria include the type of equipment for
    which the service is requested, as well as the maker and type of it depending on the
    equipment. You may choose whether the service is performed by a local supplier only or
    whether travelling service suppliers may be contacted to provide a quotation as well.
    Finally, you may choose the certification necessary that a service supplier should be able
    to demonstrate (i.e. approved by a specific Classification Society or maker).`,
    type: [TypeType.MANAGER, TypeType.SUPPORT],
  },
  {
    question:
      'How do I know the supplier I found is credible (as Ship Manager)?',
    answer: `Before a service supplier is included in our platform, the relevant information included in their profile is verified by our team to ensure its validity. After matching the service request with the service suppliers you are able to see the rating of each service supplier (satisfaction grading of previous customers), as well as navigate to their profile to see all their certification and more details about their organization and expertise.`,
    type: [TypeType.MANAGER, TypeType.SUPPORT],
  },
  {
    question: 'What is the price for using bid2board (as Ship Manager)?',
    answer: `Having created your company profile along with having prepared the technical details for the ships of your fleet, there is a yearly maintenance fee per ship for using the platform which will become applicable only after the first service order confirmation for each specific ship. Afterwards, you have the option to pay as you use the platform with a fixed fee for each confirmed order, or purchase “service bundles” of 10, 20, 50, 100 or 200 services at a discount.`,
    type: [TypeType.HOMEPAGE, TypeType.MANAGER, TypeType.SUPPORT],
  },
  {
    question: 'What is the price for using bid2board (as Service Supplier)?',
    answer: `You do not pay if you don’t get paid. You can contact us and create your profile with
    bid2board completely free. There is a yearly maintenance fee for using the platform
    which will become applicable only after the first order confirmation that you will receive
    from a ship owner / manager. Afterwards, you have the option to pay as you use the
    platform with a fixed fee for each confirmed service awarded to you, or purchase
    “service bundles” of 10, 20, 50, 100 or 200 services at a discount.`,
    type: [TypeType.HOMEPAGE, TypeType.SUPPLIER, TypeType.SUPPORT],
  },
  {
    question:
      'Does bid2board affect the invoice handling for the provided service?',
    answer: `bid2board does not interfere with the invoicing process. After the successful completion
    of a service the invoice is issued from the service supplier directly to the ship owner /
    manager.`,
    type: [TypeType.SUPPLIER, TypeType.MANAGER, TypeType.SUPPORT],
  },

  {
    question:
      'Which ports and which ship equipment is covered by the platform?',
    answer: `bid2board covers all technical services that may occur on the main commercial ship
    types. Starting with the main shipping routes and most common ports where technical
    services take place, bid2board’s network increases continuously as more local and
    travelling service suppliers join the platform.`,
    type: [TypeType.MANAGER, TypeType.SUPPORT],
  },
  {
    question: `How are the quotations ranked in the bidding process? Is price the only factor?`,
    answer: `Received offers are presented in Lump-Sum and Man-hours offers. For each category the ranking algorithm includes the suppliers’ rating, the quality of their spare parts (original, OEM, reconditioned, non-original). Thus, in some cases an offer standing in first place may not be necessarily the cheapest one.`,
    type: [TypeType.SUPPLIER, TypeType.MANAGER, TypeType.SUPPORT],
  },

  {
    question: `Is it possible to quote in man-hours or is lump-sum offers the only option?`,
    answer: `The platform offers the flexibility to service suppliers to organize their offer in whichever way they prefer.`,
    type: [TypeType.SUPPLIER, TypeType.SUPPORT],
  },
  {
    question: `How do we distinguish local versus travelling suppliers?`,
    answer: `We consider a supplier to be “local” if they are situated at a distance that can be normally covered by road network within half a working day time space. Therefore, depending on the geographical area the distance covering “local” suppliers may differ.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `What about privacy and data protection related to technical problems onboard my ships (as Ship Manager)?`,
    answer: `Ship owners have the option to submit a service request anonymously. Regarding the platform’s data protection and <a href='/privacy-policy'>privacy policy</a> you can find more information on privacy policy.  Company policy about GDPR data is implemented.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `Is there a possibility that a service request is not matched by any supplier? What happens then (as Ship Manager)?`,
    answer: `There is a possibility that the requested service in the specific location of request is not covered by any of the service suppliers included in our network. In such a case, we will inform you that your request will be handled manually by our team to try and deliver the requested service for your vessels.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `How much time is allowed for me to prepare my quotation (as Service Supplier)?`,
    answer: `Every service request includes the time period for which it will remain active. The ship manager however may choose their preferred service supplier at any given time, therefore a timely reaction and offer submission may conclude in a successful service for your company.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `How do I make an urgent request (as Ship Manager)?`,
    answer: `Every service request includes the time period for which it will remain active. An urgent request will typically have some hours of allowed time for the suppliers to prepare a quotation and submit their offers.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `How many times am I allowed to edit my service offer (as Service Supplier)?`,
    answer: `As long as the service request is active, you may improve your offer as many times as you wish to better position your offer against the competition.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `What happens if the ship itinerary changes?`,
    answer: `In cases in which the initial service request is subject to changes either in date or port the ship manager has the possibility to change this information and re-submit the service request to receive offers. It is for this reason that even after accepting a service offer, the ship manager will require at a second step to confirm that the itinerary and dates remain unchanged.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `Very often it is necessary to exchange details before arranging a service or providing an offer? How can this be done through the platform?`,
    answer: `Throughout the process a chat is available and can be used to transfer additional information or clarifications between the service supplier and the ship manager. The chat is private between the two.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `Can I make a service request for more than one equipment?`,
    answer: `No, each service request is dedicated to a specific technical equipment. You can create a new service request for a different technical equipment.`,
    type: [TypeType.SUPPORT],
  },
  {
    question: `What is the verification process for a service supplier?`,
    answer: `The information included in the profile of a service supplier is verified by our team. Especially information regarding licenses and approvals are cross-checked against the databases of issuing organizations.`,
    type: [TypeType.SUPPORT],
  },
];

export default faqs;
